module.exports = __webpack_public_path__ + "img/pin.962e80be.svg";